/**
 * True when running inside a Capacitor native shell (iOS/Android).
 *
 * Capacitor's native bridge injects `window.Capacitor` before the app boots,
 * so this works without bundling @capacitor/core into the web build.
 */
interface CapacitorGlobal {
  isNativePlatform?: () => boolean;
  getPlatform?: () => string;
  isPluginAvailable?: (name: string) => boolean;
}

function capacitorGlobal(): CapacitorGlobal | undefined {
  return (globalThis as { Capacitor?: CapacitorGlobal }).Capacitor;
}

export function isNativeShell(): boolean {
  return capacitorGlobal()?.isNativePlatform?.() === true;
}

/** 'android' | 'ios' inside a native shell, otherwise null (web). */
export function nativePlatform(): string | null {
  return isNativeShell() ? (capacitorGlobal()?.getPlatform?.() ?? null) : null;
}

/**
 * True when the running native shell includes the named plugin. A store build older
 * than the web bundle (OTA skew) may lack it — feature-detect before calling.
 */
export function isNativePluginAvailable(name: string): boolean {
  return isNativeShell() && capacitorGlobal()?.isPluginAvailable?.(name) === true;
}
